/*!

=========================================================
* Material Dashboard React - v1.9.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// @material-ui/icons
import DashboardIcon from "@material-ui/icons/Dashboard";
import ConditionCampaignsACA from "../Pages/ACA/ACAconditionCampaigns.page";
import GapHccSummaryACA from "../Pages/ACA/ACAgapHccSummary.page";
import GapMemberSummaryACA from "../Pages/ACA/ACAgapMemberSummary.page";
//import ExecutiveSummary from './Pages/executiveSummary.page';
//import ReportedHccSummary from './Pages/repotedHccSummary.page';
import ReportedHccSummaryACA from '../Pages/ACA/ACAreportedHccSummary.page'
import ReportedMemberSummaryACA from '../Pages/ACA/ACAreportedMemberSummary.page';
import ACAChartReviewHccSummary from '../Pages/ACA/ACAChartReviewHCCSummary.page';
import ACAChartReviewMemberSummary from '../Pages/ACA/ACAChartReviewMemberSummary.page';
import ProviderReconSummary from '../Pages/ACA/ACAProviderReconSummary.page';
import ReconSummary from '../Pages/ACA/ACAReconSummary.page.js';
import MetricsACA from "../Pages/ACA/ACAmetrics.page";
import RarsdComparisonACA from "../Pages/ACA/ACArarsdComparison.page";
import ListRoundedIcon from '@material-ui/icons/ListRounded';
import MonetizationOnOutlinedIcon from '@material-ui/icons/MonetizationOnOutlined';
import WcOutlinedIcon from '@material-ui/icons/WcOutlined';
import PermIdentityTwoToneIcon from '@material-ui/icons/PermIdentityTwoTone';
import ACAChartReviewOverallSummary from '../Pages/ACA/ACAChartReviewOverallSummary.page';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import BeachAccessIcon from '@material-ui/icons/BeachAccess';
import BookIcon from '@material-ui/icons/Book';
import PersonIcon from '@material-ui/icons/Person';
import CameraIcon from '@material-ui/icons/Camera';
import FilterHdrIcon from '@material-ui/icons/FilterHdr';
import AssessmentSharpIcon from '@material-ui/icons/AssessmentSharp';
import GrainIcon from '@material-ui/icons/Grain';
import FingerprintSharpIcon from '@material-ui/icons/FingerprintSharp';
import HorizontalSplitIcon from '@material-ui/icons/HorizontalSplit';
import ACACRProviderSummary from '../Pages/ACA/ACAChartReviewProviders.page';
import PCPMemberDetailsACA from '../Pages/ACA/ACAPCP1.page';
import PGPDetailsMedicare from '../Pages/MedicarePage/MedicarePGP.page';
import PGPDetailsACA from '../Pages/ACA/ACAPPGSummary.page';
import PCPDetailsACA from '../Pages/ACA/ACAPCP.page';

//import Icon from '@material-ui/icons/Report';
import ReportGeneration from '../Pages/Reports/ReportGeneration.page';
import HeatChartDemo from '../Pages/Reports/HeatChartDemo';
import TreeMapDemo from '../Pages/Reports/TreeMapDemo';
import TimelineIcon from '@material-ui/icons/Timeline';
import PieChartIcon from '@material-ui/icons/PieChart';
import DescriptionIcon from '@material-ui/icons/Description';

import ACAChartReviewOverallSummaryPage from "../Pages/ACA/ACAChartReviewOverallSummary.page";
import ACAChartReviewMemberSummaryPage from "../Pages/ACA/ACAChartReviewMemberSummary.page";

import MaoChartReviewOverallSummaryPage from "../Pages/MedicarePage/MaoChartReviewOverallSummary.page";
import MaoChartReviewMemberSummaryPage from "../Pages/MedicarePage/MaoChartReviewMemberSummary.page";
import MaoChartReviewProviderSummaryPage from "../Pages/MedicarePage/MaoChartReviewProviderSummary.page";
import MaoReportedMemberSummaryPage from "../Pages/MedicarePage/MaoReportedMemberSummary.page";
import MaoEncountersSummaryPage from "../Pages/MedicarePage/MaoEncountersSummary.page";
import MaoEncounterComparisonPage from "../Pages/MedicarePage/MaoEncounterComparison.page";
import MaoChartReviewPage from "../Pages/MedicarePage/MaoChartReview.page";
import MaoGapMemberSummaryPage from "../Pages/MedicarePage/MaoGapMemberSummary.page";
import MaoGapHccSummaryPage from "../Pages/MedicarePage/MaoGapHccSummary.page";
import MaoGapsByPCPPage from "../Pages/MedicarePage/MaoGapsByPCP.page";
import MaoProviderRetrospectiveGapsPage from "../Pages/MedicarePage/MaoProviderRetrospectiveGaps.page";
import MaoReportedHccSummaryPage from "../Pages/MedicarePage/MaoReportedHccSummary.page";
import MaoChartReviewHccSummaryPage from "../Pages/MedicarePage/MaoChartReviewHccSummary.page";
import MaoMemberSummaryPage from "../Pages/MedicarePage/MaoMemberSummary.page";
import MaoForecastSummaryPage from "../Pages/MedicarePage/MaoForecastSummary.page";
import PCPDetailsMedicare from '../Pages/MedicarePage/MedicarePCP.page';
import MemberUtilizationPage from "../Pages/Utilization/MemberUtilization.page";
import ServiceStatisticsPage from "../Pages/Utilization/ServiceStatistics.page";
import HighNeedUtilizationPage from "../Pages/Utilization/HighNeedUtilization.page";
import SUServiceUtilization from "../Pages/Utilization/SUServiceUtilizationSummary";
import ProviderUtilization from "../Pages/Utilization/ProviderUtilisation";
import AWSS3Download from "../Pages/Reports/AWSS3Download";
import RangeSliderDemo from "../Pages/Reports/RangeSliderDemo";

import HealthcareInsightsPage from "../Pages/KPI/healthcare_insights.page";
import ProviderGroupPage from "../Pages/KPI/provider_group.page";
import ProviderPerformancePage from "../Pages/KPI/provider_performance.page";
import HealthcareDashboardPage from "../Pages/KPI/healthcareDashboard.page";
import ConditionalPredicition from "../Pages/MedicarePage/ConditionalPrediction.page";
import RiskStratification from "../Pages/MedicarePage/RiskStratification.page";
import QSDashboardMedicareMemberDetails from "../Pages/MedicarePage/QSDashboardMedicareMemberDetails";
import QSDashboardMedicarePpgMetrics from "../Pages/MedicarePage/QSDashboardMedicarePpgMetrics";
import QSDashboardMedicareMemberRafSummary from "../Pages/MedicarePage/QSDashboardMedicareMemberRafSummary";
import QSDashboardMedicareGapDetails from "../Pages/MedicarePage/QSDashboardMedicareGapDetails";
import QSDashboardACAGapDetails from "../Pages/ACA/QSDashboardACAGapDetails.js";
import QSDashboardACAMemberDetail from "../Pages/ACA/QSDashboardACAMemberDetail.js";
import QSDashboardACAMemberRafSummary from "../Pages/ACA/QSDashboardACAMemberRafSummary.js";
import QSDashboardACAPPGMetric from "../Pages/ACA/QSDashboardACAPPGMetric.js";
import MedicaidProviderMetric from "../Pages/Medicaid/MedicaidProviderMetric.js";
import MedicaidPPGMetricsDashboard from "../Pages/Medicaid/MedicaidPPGMetricsDashboard.js";
import MedicaidMemberDetailsDashboard from "../Pages/Medicaid/MedicaidMemberDetailsDashboard.js";
import config from '../assets/constants/slug.config.json';
import MedicareQSClaimHCCReconciliationDashboard from "../Pages/MedicarePage/MedicareQSClaimHCCReconciliationDashboard";
import QSDashboardMedicareROIDashboard from "../Pages/MedicarePage/QSDashboardMedicareROIDashboard.js";

import QSDashboardACAROIDashboard from "../Pages/ACA/QSDashboardACAROIDashboard.js";

const dynamicRoutes = JSON.parse(localStorage.getItem('dashboardJSON'));

const dashboardRoutes = [
  {
    name: "ACA Insights",
    icon: TimelineIcon,
    layout: "/layout",
    permissionSlug: 'aca_insights_10',
    path: '',
    module: "ACA",
    subRoutes: [
      {
        path: "/acaMemberRafSummary",
        name: "Member RAF Summary",
        icon: PersonIcon,
        component: QSDashboardACAMemberRafSummary,
        layout: "/layout",
        permissionSlug: config.aca_member_raf_summary
      },
      {
        path: "/acaMemberDetail",
        name: "Member Detail",
        icon: PersonIcon,
        component: QSDashboardACAMemberDetail,
        layout: "/layout",
        permissionSlug: config.aca_member_detail
      },
      {
        path: "/acaPPGMetric",
        name: "PPG Metric",
        icon: PersonIcon,
        component: QSDashboardACAPPGMetric,
        layout: "/layout",
        permissionSlug: config.aca_ppg_metric
      },
      {
        path: "/acaGapDetails",
        name: "Gap Details",
        icon: PersonIcon,
        component: QSDashboardACAGapDetails,
        layout: "/layout",
        permissionSlug: config.aca_gap_details
      },
      {
        path: "/qs_aca_roi_dashboard",
        name: "ROI Analysis",
        icon: PersonIcon,
        component: QSDashboardACAROIDashboard,
        layout: "/layout",
        permissionSlug: config.aca_roi_analysis
      },
      {
        path: "/acaReportedMemberSummary",
        name: "Reported Member Summary",
        icon: PersonIcon,
        component: ReportedMemberSummaryACA,
        layout: "/layout",
        permissionSlug: config.reported_member_summary
      },
      {
        name: "Reported HCC Summary",
        icon: AssessmentSharpIcon,
        path: '/acaReportedHccSummary',
        component: ReportedHccSummaryACA,
        layout: "/layout",
        permissionSlug: config.reported_hcc_summary
      },
      {
        path: "/acaMetrics",
        name: "ACA Metrics",
        icon: FingerprintSharpIcon,
        component: MetricsACA,
        layout: "/layout",
        permissionSlug: config.aca_metrics
      },
      {
        path: "/healthcare/dashboard",
        name: "HealthCare Insights",
        icon: MonetizationOnOutlinedIcon,
        component: HealthcareDashboardPage,
        layout: "/layout",
        permissionSlug: config.healthcare_insights
      },
    ]
  },
  {
    name: "ACA Gap Analysis",
    icon: TimelineIcon,
    layout: "/layout",
    permissionSlug: config.aca_gap_analysis,
    path: '',
    module: "ACA",
    subRoutes: [
      {
        path: "/acaGapMemberSummary",
        name: "Gap Member Summary",
        icon: MonetizationOnOutlinedIcon,
        component: GapMemberSummaryACA,
        layout: "/layout",
        permissionSlug: config.gap_member_summary,
      },
      {
        path: "/acaGapHccSummary",
        name: "Gap Hcc Summary",
        icon: ListRoundedIcon,
        component: GapHccSummaryACA,
        layout: "/layout",
        permissionSlug: config.gap_hcc_summary,
      },
      {
        path: "/acaRarsdAnalysis",
        name: "RARSD Comparison",
        icon: CameraIcon,
        component: RarsdComparisonACA,
        layout: "/layout",
        permissionSlug: config.rarsd_comparison,
      },

    ]
  },
  {
    name: "PROVIDER SUMMARY",
    icon: ListRoundedIcon,
    layout: "/layout",
    permissionSlug: config.provider_summary,
    path: '',
    module: "ACA",
    subRoutes: [{
      path: "/pgpDetails",
      name: "PPG Summary",
      icon: MonetizationOnOutlinedIcon,
      component: PGPDetailsACA,
      layout: "/layout",
      permissionSlug: config.ppg_summary,
    },
    {
      path: "/pcpDetails",
      name: "PCP Level Summary",
      icon: MonetizationOnOutlinedIcon,
      component: PCPDetailsACA,
      layout: "/layout",
      permissionSlug: config.pcp_level_summary,
    }
    ]
  },
  {
    name: "ChartReview Data Analytics",
    icon: PieChartIcon,
    layout: "/layout",
    permissionSlug: config.chartreview_data_analytics,
    path: '',
    module: "ACA",
    subRoutes: [
      {
        path: "/overall_summary",
        name: " Overall  Summary",
        icon: FilterHdrIcon,
        component: ACAChartReviewOverallSummaryPage,
        layout: "/layout",
        permissionSlug: config.overall_summary,
      },
      {
        path: "/member_summary",
        name: "Member Summary",
        icon: WcOutlinedIcon,
        component: ACAChartReviewMemberSummaryPage,
        layout: "/layout",
        permissionSlug: config.member_summary,
      },
      {
        path: "/acaCRHCCSummary",
        name: "HCC Summary",
        icon: HorizontalSplitIcon,
        component: ACAChartReviewHccSummary,
        layout: "/layout",
        permissionSlug: config.hcc_summary,
      },
      {
        path: "/acaProviders",
        name: "HCC Coding Opportunities",
        icon: HorizontalSplitIcon,
        component: ACACRProviderSummary,
        layout: "/layout",
        permissionSlug: config.hcc_coding_opportunities,
      },
      {
        path: "/acaReconciliationSummary",
        name: "Member Reconciliation",
        icon: AccountBalanceIcon,
        component: ReconSummary,
        layout: "/layout",
        permissionSlug: config.member_reconciliation,
      },
      {
        path: "/acaProviderSummary",
        name: " Provider Reconciliation",
        icon: GrainIcon,
        component: ProviderReconSummary,
        layout: "/layout",
        permissionSlug: config.provider_reconciliation,
      },
    ]
  },
  {
    name: 'REPORTS',
    icon: DescriptionIcon,
    layout: "/layout",
    permissionSlug: config.reports,
    path: '',
    module: "ACA",
    subRoutes: [
      {
        path: "/reportgeneration",
        name: "Report Generation",
        icon: MonetizationOnOutlinedIcon,
        component: ReportGeneration,
        layout: "/layout",
        permissionSlug: config.report_generation,
      },
    ]
  },
  {
    name: 'MEDICARE INSIGHTS',
    icon: DescriptionIcon,
    layout: "/layout",
    permissionSlug: config.medicare_insights,
    path: '',
    module: "Medicare",
    subRoutes: [
      {
        path: "/medicare/qs_member_raf_summary",
        name: "Member RAF Summary",
        icon: WcOutlinedIcon,
        component: QSDashboardMedicareMemberRafSummary,
        layout: "/layout",
        permissionSlug: config.medicare_member_raf_summary,
      },
      {
        path: "/medicare/qs_member_details",
        name: "Member Details",
        icon: WcOutlinedIcon,
        component: QSDashboardMedicareMemberDetails,
        layout: "/layout",
        permissionSlug: config.medicare_member_details_qs_dashboard,
      },
      {
        path: "/medicare/qs_ppg_metrics",
        name: "PPG Metrics",
        icon: WcOutlinedIcon,
        component: QSDashboardMedicarePpgMetrics,
        layout: "/layout",
        permissionSlug: config.medicare_ppg_dashboard,
      },
      {
        path: "/medicare/qs_gap_details",
        name: "Gap Details",
        icon: WcOutlinedIcon,
        component: QSDashboardMedicareGapDetails,
        layout: "/layout",
        permissionSlug: config.medicare_gap_details,
      },
      {
        path: "/medicare/medicare_claim_hcc_reconcialiation",
        name: "MAO004 - Claim HCC Reconciliation",
        icon: WcOutlinedIcon,
        component: MedicareQSClaimHCCReconciliationDashboard,
        layout: "/layout",
        permissionSlug: config.medicare_claim_hcc_reconciliation,
        },
         {
        path: "/medicare/qs_medicare_roi_dashboard",
        name: "ROI Analysis",
        icon: WcOutlinedIcon,
        component: QSDashboardMedicareROIDashboard,
        layout: "/layout",
        permissionSlug: config.medicare_roi_analysis,
      },
      {
        path: "/medicare/reported_member_summary",
        name: "Reported Member Summary",
        icon: MonetizationOnOutlinedIcon,
        component: MaoReportedMemberSummaryPage,
        layout: "/layout",
        permissionSlug: config.medicare_reported_member_summary,
      },
      {
        path: "/medicare/reported_hcc_summary",
        name: "Reported HCC Summary",
        icon: MonetizationOnOutlinedIcon,
        component: MaoReportedHccSummaryPage,
        layout: "/layout",
        permissionSlug: config.medicare_reported_hcc_summary,
      },
      /* {
        path: "/medicare/forecast_summary",
        name: "Forecasting",
        icon: WcOutlinedIcon,
        component: MaoForecastSummaryPage,
        layout: "/layout"
      }, */
    ]
  },
  {
    name: 'Medicare Gap Analysis ',
    icon: DescriptionIcon,
    layout: "/layout",
    permissionSlug: config.medicare_gap_analysis,
    path: '',
    module: "Medicare",
    subRoutes: [
      {
        path: "/medicare/gap_member_summary",
        name: "Gap Member Summary",
        icon: MonetizationOnOutlinedIcon,
        component: MaoGapMemberSummaryPage,
        layout: "/layout",
        permissionSlug: config.medicare_gap_member_summary,
      },
      {
        path: "/medicare/gap_hcc_summary",
        name: "Gap HCC Summary",
        icon: MonetizationOnOutlinedIcon,
        component: MaoGapHccSummaryPage,
        layout: "/layout",
        permissionSlug: config.medicare_gap_hcc_summary,
      },
      {
        path: "/medicare/gap_by_pcp",
        name: "Gaps by PCP",
        icon: MonetizationOnOutlinedIcon,
        component: MaoGapsByPCPPage,
        layout: "/layout",
        permissionSlug: config.gaps_by_pcp,
      },
      {
        path: "/medicare/provider_retrospective_gaps",
        name: "Provider Retrospective Summary",
        icon: MonetizationOnOutlinedIcon,
        component: MaoProviderRetrospectiveGapsPage,
        layout: "/layout",
        permissionSlug: config.provider_retrospective_summary,
      },
    ],
  },
  {
    name: 'MAO 04 Reconciliation ',
    icon: DescriptionIcon,
    layout: "/layout",
    permissionSlug: config.mao_04_reconciliation,
    path: '',
    module: "Medicare",
    subRoutes: [
      {
        path: "/medicare/member_summary",
        name: "Member Summary",
        icon: MonetizationOnOutlinedIcon,
        component: MaoMemberSummaryPage,
        layout: "/layout",
        permissionSlug: config.medicare_member_summary,
      },
      {
        path: "/medicare/encounters_summary",
        name: "Encounters Summary",
        icon: MonetizationOnOutlinedIcon,
        component: MaoEncountersSummaryPage,
        layout: "/layout",
        permissionSlug: config.encounters_summary,
      },
      {
        path: "/medicare/encounter_comparison",
        name: "MAO Comparison Summary",
        icon: MonetizationOnOutlinedIcon,
        component: MaoEncounterComparisonPage,
        layout: "/layout",
        permissionSlug: config.mao_comparison_summary,
      },
      {
        path: "/medicare/chart_review",
        name: "Chart review summary",
        icon: MonetizationOnOutlinedIcon,
        component: MaoChartReviewPage,
        layout: "/layout",
        permissionSlug: config.chart_review_summary,
      },
    ]
  },
  {
    name: "ChartReview Data Analytics ",
    icon: PieChartIcon,
    layout: "/layout",
    permissionSlug: config.medicare_chartreview_data_analytics,
    path: '',
    module: "Medicare",
    subRoutes: [
      {
        path: "/medicare/overall_summary",
        name: "Overall  Summary",
        icon: FilterHdrIcon,
        component: MaoChartReviewOverallSummaryPage,
        layout: "/layout",
        permissionSlug: config.medicare_overall_summary,
      },
      {
        path: "/medicare/review_member_summary",
        name: "Member Summary",
        icon: WcOutlinedIcon,
        component: MaoChartReviewMemberSummaryPage,
        layout: "/layout",
        permissionSlug: config.member_summary_chart,
      },
      {
        path: "/medicare/review_hcc_summary",
        name: "HCC Summary",
        icon: WcOutlinedIcon,
        component: MaoChartReviewHccSummaryPage,
        layout: "/layout",
        permissionSlug: config.medicare_hcc_summary,
      },
      {
        path: "/medicare/provider_summary",
        name: "Provider Summary",
        icon: WcOutlinedIcon,
        component: MaoChartReviewProviderSummaryPage,
        layout: "/layout",
        permissionSlug: config.medicare_provider_summary,
      },
    ]
  },
  {
    name: "Utilization ",
    icon: DescriptionIcon,
    layout: "/layout",
    permissionSlug: config.utilization,
    path: '',
    module: "Medicare",
    subRoutes: [
      {
        path: "/medicare/member_utilization",
        name: "Member Utilization",
        icon: FilterHdrIcon,
        component: MemberUtilizationPage,
        layout: "/layout",
        permissionSlug: config.member_utilization,
      },
      {
        path: "/medicare/service_statistics",
        name: "Service Statistics",
        icon: FilterHdrIcon,
        component: ServiceStatisticsPage,
        layout: "/layout",
        permissionSlug: config.service_statistics,
      },
      {
        path: "/medicare/high_need_utilization",
        name: "High Need Member Utilization",
        icon: FilterHdrIcon,
        component: HighNeedUtilizationPage,
        layout: "/layout",
        permissionSlug: config.high_need_member_utilization,
      },
      {
        path: "/medicare/SUServiceUtilization",
        name: "Service Utilization",
        icon: MonetizationOnOutlinedIcon,
        component: SUServiceUtilization,
        layout: "/layout",
        permissionSlug: config.service_utilization,
      },
      {
        path: "/medicare/ProviderUtilization",
        name: "Provider Utilization",
        icon: MonetizationOnOutlinedIcon,
        component: ProviderUtilization,
        layout: "/layout",
        permissionSlug: config.provider_utilization,
      },
    ]
  },
  {
    name: "Prediction",
    icon: DescriptionIcon,
    layout: "/layout",
    permissionSlug: config.prediction,
    path: '',
    module: "Medicare",
    subRoutes: [
      {
        path: "/medicare/ConditionPredictor",
        name: "Condition Predictor",
        icon: FilterHdrIcon,
        component: ConditionalPredicition,
        layout: "/layout",
        permissionSlug: config.condition_predictor,
      },
      {
        path: "/medicare/RiskStratification",
        name: "Risk Stratification Potential",
        icon: FilterHdrIcon,
        component: RiskStratification,
        layout: "/layout",
        permissionSlug: config.risk_stratification_potential,
      },
    ]
  },
  {
    name: "PROVIDER SUMMARY",
    icon: ListRoundedIcon,
    layout: "/layout",
    permissionSlug: config.medicare_provider_summary_page,
    path: '',
    module: "Medicare",
    subRoutes: [
      {
        path: "/medicare/pgpDetails",
        name: "PPG Summary",
        icon: MonetizationOnOutlinedIcon,
        component: PGPDetailsMedicare,
        layout: "/layout",
        permissionSlug: config.medicare_ppg_summary,
      },
      {
        path: "/medicare/pcpDetails",
        name: "PCP Level Summary",
        icon: MonetizationOnOutlinedIcon,
        component: PCPDetailsMedicare,
        layout: "/layout",
        permissionSlug: config.medicare_pcp_level_summary,
      }
    ]
  },
  {
    name: 'MEDICAID INSIGHTS ',
    icon: DescriptionIcon,
    layout: "/layout",
    permissionSlug: config.medicaid_insight,
    path: '',
    module: "Medicaid",
    subRoutes: [
      {
        path: "/medicaid/medicaid_member_details",
        name: "Member Detail",
        icon: WcOutlinedIcon,
        component: MedicaidMemberDetailsDashboard,
        layout: "/layout",
        permissionSlug: config.medicaid_member_detail,
      },
      {
        path: "/medicaid/medicaid_ppg_metrics",
        name: "PPG Metrics",
        icon: WcOutlinedIcon,
        component: MedicaidPPGMetricsDashboard,
        layout: "/layout",
        permissionSlug: config.medicaid_ppg_metrics,
      },
      {
        path: "/medicaid/medicaid_provider_metrics",
        name: "Provider Metric",
        icon: WcOutlinedIcon,
        component: MedicaidProviderMetric,
        layout: "/layout",
        permissionSlug: config.medicaid_provider_metrics,
      },
    ]
  },
]

// Dynamically generate routes from JSON
const groupedRoutes = Array.isArray(dynamicRoutes) 
  ? dynamicRoutes
  .filter(subRoute => subRoute.module === "raf") 
  .reduce(
    (acc, subRoute) => {
      // Check LOB and group routes accordingly
      if (subRoute.lob === "ACA") {
        acc.ACA.push({
          path: '/' + (subRoute.lob ? subRoute.lob.toLowerCase() : '')  +subRoute.path ,
          name: subRoute.name,
          icon: subRoute.icon === "PersonIcon" ? PersonIcon : DescriptionIcon, 
          component: subRoute.component, // Map component
          layout: subRoute.layout,
          permissionSlug: subRoute.permissionSlug,
          parameter_store_name: subRoute.parameter_store_name || '', 
          lob: subRoute.lob || '',
          embedConsole: subRoute.embedConsole || false,
          role: subRoute.role || '',
          isDynamic: subRoute.isDynamic || false
        });
      } else if (subRoute.lob === "Medicare") {
        acc.Medicare.push({
          path: '/' + (subRoute.lob ? subRoute.lob.toLowerCase() : '')  +subRoute.path ,
          name: subRoute.name,
          icon: subRoute.icon === "PersonIcon" ? PersonIcon : DescriptionIcon,
          component: subRoute.component, // Map component
          layout: subRoute.layout,
          permissionSlug: subRoute.permissionSlug,
          parameter_store_name: subRoute.parameter_store_name || '', 
          lob: subRoute.lob || '',
          embedConsole: subRoute.embedConsole || false,
          role: subRoute.role || '',
          isDynamic: subRoute.isDynamic || false
        });
      } else if (subRoute.lob === "Medicaid") {
        acc.Medicaid.push({
          path: '/' + (subRoute.lob ? subRoute.lob.toLowerCase() : '')  +subRoute.path ,
          name: subRoute.name,
          icon: subRoute.icon === "PersonIcon" ? PersonIcon : DescriptionIcon,
          component: subRoute.component, 
          layout: subRoute.layout,
          permissionSlug: subRoute.permissionSlug,
          parameter_store_name: subRoute.parameter_store_name || '', 
          lob: subRoute.lob || '',
          embedConsole: subRoute.embedConsole || false,
          role: subRoute.role || '',
          isDynamic: subRoute.isDynamic || false
        });
      }
      return acc;
    },
    { ACA: [], Medicare: [], Medicaid: [] } 
  )
  : { ACA: [], Medicare: [], Medicaid: [] };

// Iterate over the grouped routes and add them to dashboardRoutes
Object.keys(groupedRoutes).forEach(moduleName => {
  const moduleRoutes = groupedRoutes[moduleName];
  const route = dashboardRoutes.find(r => r.module === moduleName);
  if (route) {
    route.subRoutes = route.subRoutes || [];
    route.subRoutes = [...route.subRoutes, ...moduleRoutes];
  }
});

export default dashboardRoutes;

